import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import leftRightIcon from '../../../shared/assets/icon-arrow-left.svg'

const PrevSlide = ({ onClick, visible }) => {
  return (
    <CSSTransitionGroup
      transitionName='aw_logo'
      transitionEnterTimeout={500}
      transitionLeaveTimeout={300}
    >
      {visible &&
      <div className='aw_prev-slide' style={{ backgroundImage: `url(${leftRightIcon})` }} onClick={onClick} />
      }
    </CSSTransitionGroup>
  )
}

PrevSlide.propTypes = {
  onClick: PropTypes.func,
  visible: PropTypes.bool
}

export default PrevSlide



// WEBPACK FOOTER //
// ./src/templates/app-website/components/fixed/PrevSlide.js